<template>
  <TheMainContent>
    <RevContainer>
      <div class="mb-32 flex justify-center text-center">
        <div class="md:m-auto md:w-1/2">
          <h1 class="heading-1 my-32">TODO</h1>
          <p v-if="bmUserId" class="body-1">bm_user_id: {{ bmUserId }}</p>
        </div>
      </div>
    </RevContainer>
  </TheMainContent>
</template>

<script lang="ts" setup>
import { useRoute } from '#imports'
import { computed } from 'vue'

import { RevContainer } from '@ds/components/Container'

import TheMainContent from '~/components/TheMainContent/TheMainContent.vue'

const route = useRoute()

const bmUserId = computed(() => {
  const value = route.query.bm_user_id

  return Array.isArray(value) ? value[0] : value
})
</script>
